import { makeStyles } from '@mui/styles'; 
import { blue } from '@mui/material/colors';

const useStyles = makeStyles({
    button: {
        marginTop: '20px',
        backgroundColor: blue[500],
        color: 'white',
        height:'50px',
        width: '100%',
        '&:hover': {
            backgroundColor: blue[500],
        },
    },
});

export default useStyles;
